import { IsBoolean, IsOptional, IsString } from 'class-validator';

export class UpsertMarangatuConfigDto {
  @IsString()
  username: string;

  @IsString()
  @IsOptional()
  password?: string;

  @IsBoolean()
  @IsOptional()
  activo_compras?: boolean;

  @IsBoolean()
  @IsOptional()
  activo_ventas?: boolean;
}
